import d3 from 'd3';

class Config {

  constructor(apiURL = '../data/config.json') {
    this._apiURL = apiURL;
  }

  loadData() {
    return this._loadJSON(this._apiURL)
      .then(data => this._onLoaded(data));
  }

  _loadJSON(path) {
    return new Promise((resolve, reject) => {
      const req = d3.json(path);
      req.get((error, data) => {
        if (error) reject(Error(error));
        else resolve(data);
      });
    });
  }

  _onLoaded(data) {
    this._config = data;
    return this;
  }

  get facets() {
    return this.archive.facets;
  }

  get global() {
    return this._config.global;
  }

  get archive() {
    return this._config.archive;
  }

}

module.exports = Config;



/** WEBPACK FOOTER **
 ** D:/2016/2016 - ISI/grantorino/frontend/../../../../Marco/Dropbox (ISI Foundation)/2016 - ISI/grantorino/frontend/src/js/models/Config.es6
 **/